import "stylesheets/components/common/MessageContainer.css";
import React from "react";
import PropTypes from "prop-types";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Flash from "../../../components/common/Flash";
import Propulator from "higher-order/Propulator";
import { observable } from "mobx";
import map from "lodash/map";
import { observer, PropTypes as MobxPropTypes } from "mobx-react";

@observer
class MessageContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        if (this.props.containerId) {
            this.props.dispatcher.emit("CLEAR_FLASH_MESSAGES", { containerId: this.props.containerId });
        }
    }

    render() {
        const messages = this.props.containerId
            ? this.props.localizedMessages.get(this.props.containerId)
            : this.props.messages;

        let cssClass = "message-container";
        if (this.props.type === "flash") {
            cssClass = "flash-container";
        }
        return (
            <div className={cssClass}>
                <TransitionGroup>
                    {messages && map(messages, m => {
                        return (
                            <CSSTransition key={m.id || m.messageId} classNames="flash" timeout={500}>
                                <Flash {...m} />
                            </CSSTransition>
                        );
                    })}
                </TransitionGroup>
            </div>
        );
    }
}

MessageContainer.propTypes = {
    //TODO: Investigate proper prop type - always should be an ObservableArray
    messages: MobxPropTypes.arrayOrObservableArray,
    type: PropTypes.string,
    transitionTimeout: PropTypes.number,
    containerId: PropTypes.string
};

MessageContainer.defaultProps = {
    messages: observable([]),
    type: "flash",
    transitionTimeout: 400
};

export default Propulator(MessageContainer, { messageStore: ["messages", "localizedMessages"] });
